// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-box[data-v-5a48dda8]{align-items:flex-start;display:flex;flex-direction:column}.input-box__input[data-v-5a48dda8]{border-radius:.5rem;border-width:1px;height:2.5rem;width:100%;--tw-border-opacity:1;border-color:#bec1d2;border-color:rgba(190,193,210,var(--tw-border-opacity));padding:1rem}.input-box__label[data-v-5a48dda8]{font-size:1.125rem;line-height:1.75rem}.input-box__input--readonly[data-v-5a48dda8]{outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
